import operationType from '../operationType';
import transactionStatus from '../transactionStatus';

export default {
  totalAmount: 'Total amount',
  cpAccount: 'CP Account',
  search: 'Search',
  bankingDay: 'Banking day',
  baseAmount: 'Base amount',
  instructedAmount: 'Instructed amount',
  type: 'Type',
  counterParty: 'Counter-party (CP)',
  dateAndTime: 'Date & time',
  trnId: 'Trn ID',
  externalId: 'External ID',
  reconId: 'Recon ID',
  status: 'Status',
  bankingDayFrom: 'Banking day from',
  bankingDayTo: 'Banking day to',
  fromCreatedAt: 'From',
  toCreatedAt: 'To',
  postedAmount: 'Posted amount',
  operationType: 'Operation type',
  otherAccountNumber: 'CP Account',
  partnerTransactionId: 'Partner transaction ID',
  transactionId: 'Transaction ID',
  amount: 'Base amount',
  currency: 'Base currency',
  details: 'Details',
  account: 'Account',
  datetime: 'Date & time',
  accountId: 'Account',
  external: 'External',
  accountNumber: 'Account number',
  cellComponents: {
    OperationTypeField: {
      _: 'Type',
      operationType: 'Operation type',
      any: 'Any',
      ...operationType,
    },
    RowMenu: {
      COPY_UUID: 'Copy UUID',
      GO_TO_COUNTERPARTY: 'Go to Counterparty',
      copied: 'UUID copied to clipboard',
    },
    HeadTransactionLink: {
      fetchErrorMessage: 'Error getting head transaction data',
    },
  },
  Row: {
    thereAreNoTransactions: 'There are no transactions matching the specified filters.',
  },
  Filters: {
    KeyboardDateTimePicker: {
      from: 'From',
      to: 'To',
    },
    SelectAccount: {
      accounts: 'Accounts',
      any: 'Any',
    },
    status: {
      _: 'Status',
      any: 'Any',
      ...transactionStatus,
    },
    TextField: {
      search: 'Search',
    },
    SelectSettled: {
      any: 'Any',
      true: 'Only settled',
      false: 'Only not settled',
    },
    employee: 'Employee',
    AddedFilters: {
      operationType: 'Operation type',
      status: 'Status',
      referenceId: 'Reference ID',
      accountId: 'Account',
      accountNumber: 'Account number',
      search: 'Search',
      otherAccountNumber: 'CP Account',
      transactionId: 'Transaction ID',
      amount: 'Base amount',
      currency: 'Base currency',
    },
  },
  referenceId: 'Reference ID',
  accountOrPI: 'Account / PI',
  runningBalance: 'Running balance',
  externalSource: 'External source',
};
